export const LoginWithEmailLinkActionCodeSettings = {};

// export const API_ORIGIN = "http://35.186.153.108/api";
// export const API_ORIGIN = "http://localhost:3005/api";
// export const API_ORIGIN = "https://storeapi-lb.alkuppiya.com/api";
// export const API_ORIGIN = "https://packing-storeapi.alkuppiya.com/api"
// export const API_ORIGIN = "https://prod-storeapi.alkuppiya.com/api";
export const API_ORIGIN = "https://store-prodapi.alkuppiya.lk/api";
export const INVOICE_URL = "https://l-kuppiya-store-invoice.web.app/?";


export const STORAGE_BUCKET_ORIGIN =
  "https://storage.googleapis.com/al-kuppiya-book-store/";
